module.exports = __webpack_public_path__ + "img/page-empty.efff6a0e.png";